import { Injectable } from '@angular/core';
import { ApiService } from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class FilialService {
  constructor(private apiService: ApiService) {}

  getFilials = () => this.apiService.get('/filial-agency');

  getFilialByCity = (city_id: number) =>
    this.apiService.get(`/filial-agency/city/${city_id}`);

  getFilialByManager = (manager_id: number) =>
    this.apiService.get(`/filial-agency/by-manager/${manager_id}/`);
}
